import { createFileRoute, Link } from "@tanstack/react-router";
import { motion } from "framer-motion";
import { Ban, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BrandLogo } from "@/components/BrandLogo";
import { ThemeToggle } from "@/components/ThemeToggle";

export const Route = createFileRoute("/banned")({
  head: () => ({
    meta: [
      { title: "Account suspended — Lumvio" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: BannedPage,
});

function BannedPage() {
  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-background text-foreground">
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(900px_500px_at_50%_10%,color-mix(in_oklab,red_18%,transparent),transparent_60%)]" />

      <div className="relative z-10 flex items-center justify-between px-5 py-5 sm:px-10">
        <Link to="/">
          <BrandLogo size="sm" />
        </Link>
        <ThemeToggle />
      </div>

      <main className="relative z-10 mx-auto flex max-w-lg flex-col items-center px-5 pb-16 pt-10 text-center">
        <motion.div
          initial={{ scale: 0.85, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", stiffness: 200, damping: 18 }}
          className="relative"
        >
          <div className="absolute inset-0 rounded-full bg-red-500/30 blur-3xl" aria-hidden />
          <div className="relative flex h-20 w-20 items-center justify-center rounded-2xl border border-red-500/40 bg-red-500/10 text-red-500">
            <Ban className="h-10 w-10" strokeWidth={1.5} />
          </div>
        </motion.div>

        <h1 className="mt-6 font-serif text-3xl leading-tight tracking-tight sm:text-4xl">
          Account suspended
        </h1>
        <p className="mt-4 text-balance text-sm leading-relaxed text-muted-foreground sm:text-base">
          Your account has been banned. If you believe this is a mistake, please contact support at{" "}
          <a href="mailto:contact@lumvio.co" className="font-medium text-primary hover:underline">
            contact@lumvio.co
          </a>
          .
        </p>

        <Button asChild size="lg" className="mt-8 h-11 rounded-full px-6">
          <a href="mailto:contact@lumvio.co?subject=Account%20appeal">
            <Mail className="me-2 h-4 w-4" /> Contact support
          </a>
        </Button>
      </main>
    </div>
  );
}
